// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hos-addendum-container {
  padding: 0;
  position: relative;
}

.hos-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: 11000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.25s ease-out;
}

.hos-loading-card {
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 380px;
  width: 90%;
}

button.reload-btn {
  width: 49px;
  height: 39px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(106, 206, 106, 0.1) url('reload.4f948bc26ec6cc5d.svg') no-repeat center center !important;
  border-radius: 5px !important;
  border: none !important;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
}
button.reload-btn:hover:not(:disabled) {
  background-color: rgba(106, 206, 106, 0.2) !important;
}
button.reload-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
button.reload-btn.is-loading {
  animation: reload-spin 0.9s linear infinite;
}

@keyframes reload-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.badge {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.badge-new {
  background-color: #e0f2fe;
  color: #0284c7;
  border: 1px solid #bae6fd;
}
.badge-subsequent {
  background-color: #fef3c7;
  color: #d97706;
  border: 1px solid #fde68a;
}
.badge-signed {
  background-color: #dcfce7;
  color: #15803d;
  border: 1px solid #86efac;
}
.badge-expired {
  background-color: #fee2e2;
  color: #b91c1c;
  border: 1px solid #fca5a5;
}
.badge-superseded {
  background-color: #fef2f2;
  color: #991b1b;
  border: 1px dashed #fca5a5;
}
.badge-resends {
  background-color: #f1f5f9;
  color: #475569;
  border: 1px solid #cbd5e1;
  text-transform: none;
  font-size: 11px;
  font-weight: 600;
}

.tabs-nav {
  border-bottom: 2px solid #e2e8f0;
}
.tabs-nav .tab-btn {
  background: transparent;
  border: none;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all 0.2s ease;
}
.tabs-nav .tab-btn:hover {
  color: #0284c7;
}
.tabs-nav .tab-btn.active {
  color: #0284c7;
  border-bottom-color: #0284c7;
}
.tabs-nav .tab-btn .history-count {
  font-size: 12px;
  color: #94a3b8;
}

.clock-banner {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
}
.clock-banner .clock-title {
  font-weight: 700;
  font-size: 13px;
  color: #166534;
}
.clock-banner .clock-badge {
  background: #dcfce7;
  color: #15803d;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
}
.clock-banner .clock-desc {
  font-size: 12px;
  color: #15803d;
}
.clock-banner .clock-meta {
  font-size: 12px;
  color: #166534;
}
.clock-banner .clock-meta em {
  font-size: 11px;
}

.failed-banner {
  background: #fef2f2;
  border: 1px solid #fca5a5;
  border-radius: 8px;
  color: #7f1d1d;
}
.failed-banner .failed-title {
  font-weight: 700;
  font-size: 13px;
  color: #991b1b;
}

.signed-banner {
  background: #f0fdf4;
  border: 1px solid #86efac;
  border-radius: 8px;
}
.signed-banner .signed-title {
  font-weight: 700;
  font-size: 13px;
  color: #166534;
}

.status-pill {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
}
.status-pill.status-draft {
  background: #f1f5f9;
  color: #64748b;
}
.status-pill.status-pending {
  background: #fef3c7;
  color: #b45309;
}
.status-pill.status-signed {
  background: #dcfce7;
  color: #15803d;
}
.status-pill.status-failed {
  background: #fee2e2;
  color: #b91c1c;
}
.status-pill.status-superseded {
  background: #fef2f2;
  color: #991b1b;
  border: 1px dashed #fca5a5;
}

.upload-dropzone {
  border: 2px dashed #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  cursor: pointer;
  transition: all 0.2s;
}
.upload-dropzone:hover {
  border-color: #0284c7;
  background: #f0f9ff;
}

.dynamic-prep-info {
  background: #f1f5f9;
  border-radius: 6px;
}
.dynamic-prep-info .dynamic-list {
  margin: 0;
}
.dynamic-prep-info .dynamic-list li {
  line-height: 1.6;
  color: #475569;
}

.alert-warning {
  background-color: #fffbeb;
  border: 1px solid #fef3c7;
}

.history-card {
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.history-card .status-pill {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
}
.history-card .status-pill.status-draft {
  background: #f1f5f9;
  color: #64748b;
}
.history-card .status-pill.status-pending {
  background: #fef3c7;
  color: #b45309;
}
.history-card .status-pill.status-signed {
  background: #dcfce7;
  color: #15803d;
}
.history-card .status-pill.status-expired {
  background: #fee2e2;
  color: #b91c1c;
  border: 1px solid #fca5a5;
}
.history-card .status-pill.status-superseded {
  background: #fef2f2;
  color: #991b1b;
  border: 1px dashed #fca5a5;
}
.history-card .history-tag {
  font-size: 9px;
  font-weight: 700;
  padding: 2px 4px;
  border-radius: 3px;
  background: #e2e8f0;
  color: #475569;
}

.note-box {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
}

/* The signing clock start date dialog opens from within the upload sidebar. It must appear in front of the sidebar (z-index 1100). */
::ng-deep .p-dialog-mask {
  z-index: 1200 !important;
}

/* Its date field: the typed date and the calendar button sit apart, the text is padded like every other
   field on this screen, and both keep their own rounded corners. */
::ng-deep .hos-upload-date.p-calendar {
  gap: 8px;
}
::ng-deep .hos-upload-date.p-calendar .p-inputtext {
  padding: 12px 16px !important;
  border: 1px solid #D1D5DB;
  border-radius: 6px !important;
  font-size: 14px;
}
::ng-deep .hos-upload-date.p-calendar .p-datepicker-trigger {
  border-radius: 6px !important;
}

/* The calendar is appended to the page so the whole month shows, which put it behind the dialog's mask
   above (PrimeNG gave it 1050): it opened, but nobody could see it. */
::ng-deep .hos-upload-date-panel {
  z-index: 1210 !important;
}

/* Ensure inputs, labels and calendar in HOS addendum match E-Sign exactly */
::ng-deep .hos-addendum-sidebar .p-sidebar-header {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}
::ng-deep .hos-addendum-sidebar .p-sidebar-content {
  padding-top: 0.5rem !important;
}
::ng-deep .hos-addendum-sidebar .sidebar-form {
  padding: 25px;
}
::ng-deep .hos-addendum-sidebar .sidebar-form label, ::ng-deep .hos-addendum-sidebar .sidebar-form .p-checkbox-label {
  font-family: "Montserrat", sans-serif !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  line-height: 30px !important;
  color: #1F2937 !important;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-inputtext {
  height: 54px !important;
  border: 1px solid #D1D5DB !important;
  border-radius: 6px !important;
  padding: 12px 16px !important;
  font-size: 14px !important;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-input-icon-left {
  position: relative;
  display: flex;
  align-items: center;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-input-icon-left .gc-input-icon {
  position: absolute;
  left: 18px;
  top: 17px;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-input-icon-left .gc-input-icon img {
  width: 18px;
  height: 18px;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-input-icon-left .gc-input-icon em {
  font-size: 18px;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-input-icon-left .p-inputtext {
  padding-left: 48px !important;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-calendar.disable-calendar {
  width: 100%;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-calendar.disable-calendar .p-inputtext {
  height: 54px !important;
  border: 1px solid #D1D5DB !important;
  border-radius: 6px !important;
  padding: 12px 16px 12px 48px !important;
  font-size: 14px !important;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-inputmask {
  width: 100%;
}
::ng-deep .hos-addendum-sidebar .sidebar-form textarea.p-inputtext {
  height: auto !important;
  min-height: 90px !important;
  padding: 12px 16px !important;
}
::ng-deep .hos-addendum-sidebar .sidebar-form .p-inputtext[readonly],
::ng-deep .hos-addendum-sidebar .sidebar-form .p-inputtext:disabled,
::ng-deep .hos-addendum-sidebar .sidebar-form .p-calendar.p-disabled .p-inputtext,
::ng-deep .hos-addendum-sidebar .sidebar-form .p-inputmask.p-disabled .p-inputtext {
  background-color: #f8fafc !important;
  color: #475569 !important;
  border-color: #e2e8f0 !important;
  cursor: default !important;
}

.p-button.btn-audit-log {
  background: #f97316;
  border-color: #f97316;
  color: #ffffff;
}
.p-button.btn-audit-log:enabled:hover {
  background: #ea580c;
  border-color: #ea580c;
  color: #ffffff;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
